module.exports = __webpack_public_path__ + "img/superior_comment.9390a870.png";